export const MenuConsumer = "MenuConsumer";
// TODO: remove Site fallback once MobileApp has been added to menus
// MobileApp uses the same visibility rules as Site for elements that predate MobileApp.
export const isVisibleForConsumer = (consumer) => (v) => v === consumer || (consumer === "MobileApp" && v === "Site");
